<template>
  <v-container py-1>
    <v-chip :color="limit - count > 0 ? 'primary' : 'error'" text-color="white">
      {{ $t('titles.tournaments.left') }}: {{ limit - count }}
    </v-chip>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <v-toolbar card flat dense color="white">
            <v-text-field
              v-model="search"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              solo
            />
            <meta-button
              v-if="limit - count > 0"
              type="new"
              @click="dialog = true"
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="complex.headers"
              :items="formatedList"
              :rows-per-page-items="[10, 25, 50]"
              :search="search"
              class="elevation-1"
              :loading="loading"
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  <v-icon
                    v-if="limit - count > 0 || props.item.confirmed"
                    color="success"
                    class="mr-1"
                    @click="setOne(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon color="error" @click="ifDelete(props.item._id)">
                    delete
                  </v-icon>
                </td>
                <td class="text-xs-center">
                  <v-avatar size="32">
                    <img :src="props.item.img" alt />
                  </v-avatar>
                </td>
                <td>{{ props.item.name }}</td>
                <td
                  v-if="type == 'teams'"
                  class="text-xs-center"
                  style="min-width: 350px"
                >
                  <template
                    v-if="props.item.categories && props.item.categories.length"
                  >
                    <template
                      v-for="(category, index) in props.item.categories"
                    >
                      <v-chip
                        :key="index + category"
                        small
                        color="primary"
                        dark
                      >
                        {{ category }}
                      </v-chip>
                    </template>
                  </template>
                  <span v-else>-</span>
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.confirmed" />
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.inscribed" />
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="submit(idDelete)"
    />
    <dialog-participant
      ref="form"
      :dialog.sync="dialog"
      :participant.sync="participant"
      :participant-ids="formatedList.map((item) => item.objectId)"
      :type="type"
      :disabled="limit - count == 0"
      :loading="loading"
      @submit="submit"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogParticipant from '@/components/widgets/dialog/DialogParticipant'

export default {
  name: 'TabParticipants',
  components: { DialogParticipant, DialogDelete },
  props: {
    type: {
      type: String,
      required: true,
      default: '',
    },
    limit: {
      type: Number,
      required: true,
      default: 0,
    },
    participants: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      dialog: false,
      dialogDelete: false,
      participant: {},
      idDelete: '',
    }
  },
  watch: {
    tournamentId() {
      this.clear()
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.tournaments.loading,
      tournamentId: (state) => state.tournaments.idSelected,
    }),
    complex() {
      let headers = [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          value: 'actions',
          sortable: false,
        },
        {
          text: this.$t('fields.users.image'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
      ]
      if (this.type === 'teams') {
        headers.push({
          text: this.$tc('models.category'),
          align: 'center',
          value: 'categories',
        })
      }
      headers = headers.concat([
        {
          text: this.$t('fields.tournaments.confirmed'),
          align: 'center',
          value: 'confirmed',
        },
        {
          text: this.$t('fields.tournaments.inscribed'),
          align: 'center',
          value: 'inscribed',
        },
      ])
      return {
        headers,
      }
    },
    formatedList() {
      return this.participants
    },
    count() {
      let participants = this.participants.filter((item) => item.confirmed)
      return participants.length
    },
  },
  methods: {
    ...mapActions({
      setUpdate: 'tournaments/update',
      fetchOne: 'tournaments/fetchOne',
    }),
    submit(idDelete) {
      let payload = {
        _id: this.tournamentId,
        users: [],
        teams: [],
      }
      if (this.type === 'teams') payload.teams = this.getList(idDelete)
      else if (this.type === 'users') payload.users = this.getList(idDelete)
      this.setUpdate(payload).then((result) => {
        this.$refs.form.cancel()
        this.fetchOne(result._id)
        this.dialogDelete = false
      })
    },
    setOne(participant) {
      this.participant = Object.assign({}, participant)
      delete this.participant.name
      this.dialog = true
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    getList(idDelete) {
      let participants = this.formatedList.map((item) => ({
        _id: item._id,
        objectId: item.objectId,
        confirmed: item.confirmed,
        inscribed: item.inscribed,
      }))
      if (!idDelete) {
        if (this.participant._id) {
          let index = participants.findIndex(
            (item) => item._id === this.participant._id
          )
          participants.splice(index, 1)
          participants.push(this.participant)
        } else participants.push(this.participant)
      } else {
        let index = participants.findIndex((item) => item._id === idDelete)
        participants.splice(index, 1)
      }

      return participants
    },
    // remove(id) {
    //   this.selected = id
    //   this.dialog = true
    // },
    // deleteTeam() {
    //   let index = this.participantList.findIndex(
    //     participant => participant._id == this.selected
    //   )
    //   this.participantList.splice(index, 1)
    //   this.updateParticipants()
    // },
    // acceptParticipant(id) {
    //   let participant = this.participantList.find(
    //     participant => participant._id == id
    //   )
    //   participant.accepted = true
    //   this.updateParticipants()
    // },
    // updateParticipants() {
    //   let participants = this.pa
    //   tournament._id = this.tournament._id
    //   if (this.type == 'teams') {
    //     tournament.teams = this.participantList
    //     tournament.users = []
    //   } else if (this.type == 'users') {
    //     tournament.users = this.participantList
    //     tournament.teams = []
    //   } else if (this.type == 'usersTeams') {
    //     tournament.teams = this.participantList
    //     tournament.users = []
    //     tournament.teams.forEach(team => {
    //       let users = team.userIds.map(userId => {
    //         return {
    //           userId,
    //           confirmed: team.confirmed,
    //           accepted: team.accepted,
    //           invitationSent: team.invitationSent
    //         }
    //       })
    //       tournament.users = tournament.users.concat(users)
    //     })
    //   } else return
    //   this.loading = true
    //   this.setUpdate(tournament)
    //     .then(() => (this.dialog = false))
    //     .finally(() => (this.loading = false))
    // },
    clear() {
      this.search = ''
      this.$refs.form.clear()
    },
  },
}
</script>
